<div class="container-fluid">
  <div class="row content-margin g-0 mb-0">
    <div class="row g-0">
      <div class="col-12 col-md-11">
        <div class="col student-ticket-status row-item" data-cy="ticket-details-card-ticketstatus"
             [ngStyle]="{'color': getTicketStatusColor(ticket?.status)}">
          <span class="icon-container">
            <fa-icon [icon]="faSign"></fa-icon>
          </span>
          <span>
            {{ ('TICKETS.STUDENT_TICKET_STATUS.' + ticket?.status)|translate }}
          </span>
        </div>
      </div>
      <div class="col-12 col-md-1 d-flex flex-column align-items-end">
        <!-- Data changes are only editable via the verification wizard now; individual edit options disabled.
        <div class="button-container">
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-outline-primary dropdown-toggle btn-icon-only"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              aria-label="Bearbeiten"
            >
              <fa-icon [icon]="faPenToSquare"></fa-icon>
              <span class="visually-hidden">Bearbeiten</span>
            </button>
            <ul class="dropdown-menu">
              @if (addressDataChangeEnabled) {
                <li>
                  <button class="dropdown-item" id="action1-btn" (click)="adjustAdressDetails()">
                    <div>
                      <div style="display: flex; flex-direction: column; align-items: start;">
                        <span>{{ 'TICKETS.BUTTON_CHANGE_ADRESS_DETAILS' | translate }}</span>
                      </div>
                    </div>
                  </button>
                </li>
              }
              @if (schoolDataChangeEnabled) {
                <li>
                  <button class="dropdown-item" id="action2-btn" (click)="adjustSchoolDetails()">
                    <div>
                      <div style="display: flex; flex-direction: column; align-items: start;">
                        <span>{{ 'TICKETS.BUTTON_CHANGE_SCHOOL_DETAILS' | translate }}</span>
                      </div>
                    </div>
                  </button>
                </li>
              }
              <li>
                <button class="dropdown-item" data-cy="action2-btn" (click)="adjustNameDetails()">
                  <div>
                    <div style="display: flex; flex-direction: column; align-items: start;">
                      <span>{{ 'TICKETS.BUTTON_CHANGE_NAME_DETAILS' | translate }}</span>
                    </div>
                  </div>
                </button>
              </li>
              <li>
                <button class="dropdown-item" data-cy="action-email-btn" (click)="adjustEmailDetails()">
                  <div>
                    <div style="display: flex; flex-direction: column; align-items: start;">
                      <span>{{ 'TICKETS.BUTTON_CHANGE_EMAIL_DETAILS' | translate }}</span>
                    </div>
                  </div>
                </button>
              </li>
            </ul>
          </div>
        </div>
        -->
      </div>
    </div>

    <div class="row myfit g-0">
      <div class="col-12 col-lg-4">
        <div class="card-text" data-cy="ticket-details-card-name">
          <div class="row-item">
              <span class="icon-container">
                <fa-icon class="mr-0" [icon]="faPerson"></fa-icon>
              </span>
            <span>
                 {{ ticket?.firstname }}
              {{ ticket?.lastname }}
              </span>
          </div>
          @if (ticket?.contactData?.email) {
            <div class="row-item" data-cy="ticket-details-card-email">
              <span class="icon-container">
                <fa-icon [icon]="faEnvelope"></fa-icon>
              </span>
              <span class="text-break">{{ ticket.contactData.email }}</span>
            </div>
          }
        </div>
      </div>
      <div class="col-12 col-lg-4">
        @if (ticket?.addressData) {
          <div class="mt-2 mt-md-0">
            <div data-cy="ticket-details-card-address">
              <div class="row-item">
                  <span class="icon-container">
                    <fa-icon [icon]="faRoad"></fa-icon>
                  </span>
                <div class="d-flex flex-column">
                  <span>
                    {{ ticket.addressData.street }} {{ ticket.addressData.addressAddition }}
                  </span>
                  <span>
                     {{ ticket.addressData.postalCode }} {{ ticket.addressData.city }}
                  </span>
                  <span>
                       {{ ticket.addressData.country | land }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="col-12 col-lg-4">
        @if (ticket?.schuljahrName) {
          <div data-cy="ticket-details-card-schuljahrName">
            <div class="row-item">
                  <span class="icon-container">
                    <fa-icon [icon]="faSchool"></fa-icon>
                  </span>
              <div class="d-flex flex-column">
                <span data-cy="ticket-details-card-schuleName">
                  {{ ticket.schuleName }}
                </span>
                <span>
                  @if (ticket?.klasseName) {
                    <span data-cy="ticket-details-card-klasseName">{{ ticket.klasseName }}</span>
                  }
                  @if (ticket?.bildungsgangName) {
                    <span data-cy="ticket-details-card-bildungsgangName">{{ ticket.bildungsgangName }}</span>
                  }
                </span>
                <span>
                  {{ ticket.schuljahrName }}
                </span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="row g-0 mt-3">
      <div class="col-12 d-flex justify-content-between align-items-center text-muted header-text">
        <div class="row-item creationdate" data-cy="ticket-details-card-creationdate-footer">
          <span class="icon-container">
             <fa-icon [icon]="faCalendarPlus"></fa-icon>
          </span>
          <span>
             {{ ('TICKETS.CREATONDATE_LABEL' | translate: {creationDate: (ticket?.createdAt | date:'dd.MM.yyyy')}) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
